import { HistoricalTrends } from "./HistoricalTrends.js";

export default HistoricalTrends;
